import { ApdmCouponCampaignSummary } from '@euler/model/apdm';

/** Rows the coupon choice card shows before 查看全部. */
export const kApdmCouponCardRows = 3;

/** What the coupon choice card shows of the store's coupon campaigns. */
export interface ApdmCouponCardChoices {
  /** The rows on the card. */
  shown: ApdmCouponCampaignSummary[];
  /** The one selected unless the user tapped another; null for none. */
  preselected: string | null;
  /** How many there are in all, when 查看全部 has more to show; else null. */
  moreTotal: number | null;
}

/**
 * The card's rows: the planner's suggestion first, then one picked from
 * the full list (which may lie past the first page), then the newest,
 * three at most. The suggestion is preselected.
 */
export function apdmCouponCardChoices(input: {
  /** The newest coupon campaigns, as read now or as the reply kept them. */
  choices: ApdmCouponCampaignSummary[];
  /** How many the store has; null when only the reply's list is known. */
  total: number | null;
  suggested: ApdmCouponCampaignSummary | null;
  picked: ApdmCouponCampaignSummary | null;
}): ApdmCouponCardChoices {
  const seen = new Set<string>();
  const shown: ApdmCouponCampaignSummary[] = [];
  for (const choice of [input.suggested, input.picked, ...input.choices]) {
    if (!choice || seen.has(choice.id)) continue;
    seen.add(choice.id);
    shown.push(choice);
    if (shown.length === kApdmCouponCardRows) break;
  }
  const total = input.total ?? input.choices.length;
  return {
    shown,
    preselected: input.suggested?.id ?? null,
    moreTotal: total > shown.length ? total : null,
  };
}
